<template>
  <div>
    <list
      row-key="SectionId"
      ref="list"
      unit="留宿自习节次管理"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canWrite()"
      :show-query="true"
      :get-data-func="api.list"
      :showReset="false"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange" size="mini">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.GradeId" @change="gradeChange" size="mini" clearable>
            <el-option
              v-for="item in gradeList"
              :key="item.GradeId"
              :value="item.GradeId"
              :label="item.Grade"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SectionNumber" label="序号" :width="isMB?60:80" align="center" />
        <el-table-column prop="Grade" label="年级" />
        <el-table-column prop="SectionName" label="节次" />
        <el-table-column prop="StartTime" label="开始时间"></el-table-column>
        <el-table-column prop="EndTime" label="结束时间"></el-table-column>
        <el-table-column prop="FaceStartTime" label="刷脸考勤开始时间" :min-width="isMB?130:''"></el-table-column>
        <el-table-column prop="FaceEndTime" label="刷脸考勤结束时间" :min-width="isMB?130:''"></el-table-column>
        <el-table-column prop="RollCallStartTime" label="手动考勤开始时间" :min-width="isMB?130:''"></el-table-column>
        <el-table-column prop="RollCallEndTime" label="手动考勤结束时间" :min-width="isMB?130:''"></el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" :min-width="isMB?140:''">
          <!-- <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.CreateTime)}}</span>
          </template> -->
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import termApi from "@/api/ed/term";
import gradeApi from "@/api/ed/grade";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ed/section").default,
      params: {
        TermId: null,
        GradeId: null,
        SectionType: 1,
      },
      termApi,
      gradeApi,
      termList: [],
      gradeList: [],
      isMB: this.$store.state.isMB,
    };
  },
  beforeMount() {
    this.termApi.list().then((res) => {
      this.termList = res.Data || [];
      if (res.Data.length > 0) {
        this.params.TermId = res.Data[0].TermId;
        sessionStorage.setItem("termId", res.Data[0].TermId);
        sessionStorage.setItem("termNumber", res.Data[0].TermNumber);
        this.query({ TermId: res.Data[0].TermId });
      }
    });
    this.gradeApi.list().then((res) => {
      this.gradeList = res.Data;
    });
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    termChange(e) {
      sessionStorage.setItem("termId", e);
      this.query({ TermId: e, GradeId: this.params.GradeId });
    },
    gradeChange(e) {
      this.query({ TermId: this.params.TermId, GradeId: e });
    },
  },
};
</script>